import CardUsers from './CardUsers';
import './CardUsers.scss';

export default CardUsers;
